<template>
    <div class="field image" :class="[ { 'no-placeholder': !label } ]">
        <div class="image-group">      
            <div
                class="image"
                :style="{
                    backgroundImage: previewUrl
                        ? 'url(' + previewUrl + ')'
                        : 'url(' + defaultAvatar + ')'
                }"
            ></div>
            <div class="actions">
                <button class="btn transparent" type="button" @click="triggerFileInput">
                    <i class="bi bi-upload"></i><span>{{ previewUrl ? 'Alterar Imagem' : 'Enviar Imagem' }}</span>
                </button>
                <button class="btn transparent" type="button" @click="removeImage" v-if="previewUrl">
                    <i class="bi bi-trash"></i><span>Remover Imagem</span>
                </button>
            </div>
            <input
                ref="fileInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="handleFileChange"
            />
        </div>
        <strong class="tip" v-if="tip">{{ tip }}</strong>
        <div class="errors" v-if="error">
            <div v-if="Array.isArray(error)" v-for="(err, index) in error" :key="index">{{ err }}</div>
            <div v-else>{{ error }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AvatarFieldComponent",
    props: {
        type: {
            type: String,
            default: "text"
        },
        name: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        value: {
            type: [String, Blob],
            default: ""
        },
        required: {
            type: String,
            default: ""
        },
        tip: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    },
    emits: [
        "value-updated",
        "event:blur",
        "event:focus",
        "event:input"
    ],
    data() {
        return {
            previewUrl: null,
            webpBlob: null,
            defaultAvatar: process.env.BASE_URL + 'images/content/user/default-avatar.webp'
        };
    },    
    computed: {
        isRequired() {
            return this.required==='required'?this.required:false;
        },
    },
    watch: {
        // value(newValue) {
        //     if (!newValue) {
        //         this.previewUrl = null;
        //         this.webpBlob = null;
        //     }
        // },
        value: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.previewUrl = null;
                    this.webpBlob = null;
                } else if (typeof newValue === 'string' && newValue.startsWith('http')) {
                    // Se for uma URL, usa diretamente
                    this.previewUrl = newValue;
                    this.webpBlob = null;
                } else if (typeof newValue === 'string' && newValue.startsWith('data:image/')) {
                    // Se for base64, usa diretamente
                    this.previewUrl = newValue;
                    this.webpBlob = null;
                } else {
                    // Outros casos (ex: Blob), pode tratar conforme necessário
                    this.previewUrl = null;
                    this.webpBlob = null;
                }
            }
        }
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        async handleFileChange(event) {
            const file = event.target.files[0];
            if (!file || !file.type.startsWith('image/')) return;

            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                img.onload = async () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);

                    canvas.toBlob((blob) => {
                        if (blob) {
                            this.webpBlob = blob;
                            this.previewUrl = URL.createObjectURL(blob);

                            // Converte o blob para base64 e emite como string
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                // reader.result é uma string base64 (data URL)
                                this.$emit("value-updated", { key: this.name, value: reader.result, type: 'image/webp' });
                            };
                            reader.readAsDataURL(blob);
                        }
                    }, 'image/webp');
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage() {
            this.previewUrl = null;
            this.webpBlob = null;
            this.$refs.fileInput.value = '';
            // Se quiser emitir null para o pai:
            this.$emit("value-updated", { key: this.name, value: null, type: 'image/webp' });
        },
        handleBlur() {
            this.$emit('event:blur');
        },
        handleFocus() {
            this.$emit('event:focus');
        },
    },
};
</script>
